var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcActionSocialInstagram({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M12 17a5 5 0 1 0 0-10 5 5 0 0 0 0 10Zm0-2a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17 8a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M2.633 5.318C2 6.584 2 8.236 2 11.54v.92c0 3.304 0 4.956.633 6.222a6 6 0 0 0 2.685 2.685C6.584 22 8.236 22 11.54 22h.92c3.304 0 4.956 0 6.222-.633a6 6 0 0 0 2.685-2.685C22 17.416 22 15.764 22 12.46v-.92c0-3.304 0-4.956-.633-6.222a6 6 0 0 0-2.685-2.685C17.416 2 15.764 2 12.46 2h-.92c-3.304 0-4.956 0-6.222.633a6 6 0 0 0-2.685 2.685ZM12.46 4h-.92c-1.684 0-2.83.002-3.715.073-.863.069-1.305.195-1.613.349a4 4 0 0 0-1.79 1.79c-.154.308-.28.75-.35 1.613C4.003 8.711 4 9.855 4 11.54v.92c0 1.684.002 2.83.073 3.715.069.863.195 1.305.349 1.613a4 4 0 0 0 1.79 1.79c.308.154.75.28 1.613.35.886.07 2.03.072 3.715.072h.92c1.684 0 2.83-.002 3.715-.073.863-.069 1.305-.195 1.613-.349a4 4 0 0 0 1.79-1.79c.154-.308.28-.75.35-1.613.07-.886.072-2.03.072-3.715v-.92c0-1.684-.002-2.83-.073-3.715-.069-.863-.195-1.305-.349-1.613a4 4 0 0 0-1.79-1.79c-.308-.154-.75-.28-1.613-.35-.886-.07-2.03-.072-3.715-.072Z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcActionSocialInstagram);
export default __webpack_public_path__ + "static/media/ic_action_social_instagram.ca06b6b6208b0be4218dd9fe8e560876.svg";
export { ForwardRef as ReactComponent };